/** @jsxImportSource @emotion/react */
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import Login from "pages/auth/login/login";
import Error from "pages/Error";
import Analytics from "pages/analytics";
import InviteLink from "pages/invite";
import Init from "pages/init";
import Register from "pages/visitors/register";
import { getUserInfo } from "apis/auth/auth";
import { useRecoilState } from "recoil";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import AddPersonalCalendar from "pages/visitors/add-personal-calendar";
import FindPassword from "pages/auth/find-password";
import Signup from "pages/auth/sign-up";
import GoogleRedirect from "pages/auth/google-redirect";
import Workspace from "pages/workspace";
import SettingNavigation from "pages/setting";
import { workspace, user, member, complainManager } from "recoil/recoilState";
import MeetingNavigation from "pages/meeting";
import SlackRedirect from "pages/auth/slack-redirect";
import VisitorsNavigation from "pages/visitors";
import { checkIsHost } from "apis/meeting-room-complain";
import ExtendsRequest from "pages/meeting/redirect/extends";
import { getMyMemberinfo } from "apis/members/my";
import { getWorkspaceInfo } from "apis/workspace";
import ChannelService from "utils/ChannelService";
import CancelReservation from "pages/meeting/redirect/cancel-rsv";
import Redirect from "pages/redirect";

function App() {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_CODE);

  const [workspaceInfo, setWorkspacesInfo] = useRecoilState(workspace);
  const [userInfo, setUserInfo] = useRecoilState(user);
  const [memberInfo, setMemberInfo] = useRecoilState(member);
  const [complainManagerInfo, setComplainManagerInfo] = useRecoilState(complainManager);
  const location = useLocation();

  const setInfo = async () => {
    const user = await getUserInfo();
    const member = await getMyMemberinfo();
    const workspace = await getWorkspaceInfo();

    if (!user.success) {
      window.location.href = "/login";
    }

    setUserInfo((prev) => ({ ...prev, ...user.user }));
    setMemberInfo((prev) => ({ ...prev, ...member.data }));
    setWorkspacesInfo((prev) => ({ ...prev, ...workspace.data }));

    if (member.data && workspace.data.mileMeetingsUsage) {
      checkIsHost().then((res) => {
        setComplainManagerInfo(res.success);
      });
    }
  };

  useEffect(() => {
    if (
      !(
        location.pathname.includes("login") ||
        location.pathname.includes("sign-up") ||
        location.pathname.includes("find-password") ||
        location.pathname.includes("config") ||
        location.pathname.includes("error") ||
        location.pathname.includes("invite") ||
        location.pathname.includes("extends") ||
        location.pathname.includes("cancel") ||
        location.pathname.includes("redirect")
      )
    ) {
      setInfo();
    }
  }, [location]);

  useEffect(() => {
    ChannelService.boot({
      pluginKey: process.env.REACT_APP_CHANNEL_ID, // fill your plugin key
    });
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Init />} />
      <Route path="/login/*" element={<Login />} />
      <Route path="/meeting/extends/:id/:state" element={<ExtendsRequest />} />
      <Route path="/meeting/cancel/:page/:id/:messageId/:memberPublicId" element={<CancelReservation />} />
      <Route path="/google/redirect/:page" element={<GoogleRedirect />} />
      <Route path="/slack/redirect/:page" element={<SlackRedirect />} />
      <Route path="/email/redirect/member-sync/:memberPublicId/:added/:removed" element={<Redirect />} />
      <Route path="/email/redirect/member-sync/:encryptWorkspaceId" element={<Redirect />} />
      <Route path="/workspace/:page" element={<Workspace />} />
      <Route path="/invite" element={<InviteLink />} />
      <Route path="/sign-up" element={<Signup />} />
      <Route path="/find-password" element={<FindPassword />} />
      <Route path="/setting/:page/:subpage?" element={<SettingNavigation />} />
      <Route path="/error/:type/:email" element={<Error />} />
      <Route path="/analytics/:page?/:subpage?" element={<Analytics />} />
      <Route path="/meeting/:page" element={<MeetingNavigation />} />
      <Route path="/meeting/:page/:subPage" element={<MeetingNavigation />} />
      <Route path="/visitors/:page/:subpage?" element={<VisitorsNavigation />} />
      <Route path="/visitors/register" element={<Register />} />
      <Route path="/visitors/register/:id" element={<Register />} />
      <Route path="/visitors/add-personal-calendar/:status/:id" element={<AddPersonalCalendar />} />
      <Route path="*" element={<Init />} />
    </Routes>
  );
}

export default App;
